import React from 'react';
import moment from 'moment';
import { displayLocalDate } from '../../../../helpers/date';

const DisplayMessage = ({ email = {}, attachmentsBaseUrl, showAttachments = false }) => {
  const date = displayLocalDate(email.date, { timeFormat: 'HH:mm'});
  return (
    <div className="mailbox-read-info">
      <div className="pull-left info">
        <h5>from:</h5>
        <h5>to:</h5>
        { date ? <h5>date:</h5> : null }
        <h5>subject:</h5>
      </div>
      <div>
        <h5>{ email.sender }&nbsp;</h5>
        <h5>{ email.recipient }&nbsp;</h5>
        { date ? <h5>{ date }</h5> : null }
        <h5>{ email.subject }&nbsp;</h5>
      </div><br/>
      <iframe id="message-preview-iframe" name="preview-frame" width="100%" height="400px" srcDoc={ email.body }></iframe><br/><br/>
      {
        email.attachments && email.attachments.length > 0 && showAttachments
          ? <fieldset>
              <legend>Attachments</legend>
              <ul>
              {
                email.attachments
                  .filter(attachment => !attachment._new && attachment.filename)
                  .map((attachment, i) => {
                    const url = attachmentsBaseUrl + (attachment.path || attachment.filename);
                    return url ? <li key={ i }><a href={ url } target="_blank">{ attachment.filename }</a></li> : null;
                  })
              }
              </ul>
            </fieldset>
          : null
      }
    </div>
  );
};

export default DisplayMessage;



// WEBPACK FOOTER //
// ./src/frontend/modules/email/message/components/DisplayMessage.jsx